import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";

import {
  getFamily,
  updateParentInfo,
  updateSpouseInfo,
  updateChildInfo,
  updateEmergencyContactInfo,
  updatePermanentAddressInfo,
  updatePresentAddressInfo,
  deleteChildInfo,
  deleteSpouseInfo,
} from "@api/family";
import {
  FamilyActions,
  getFamilySuccess,
  getFamilyFailed,
  updateParentInfoSuccess,
  updateParentInfoFailed,
  updateSpouseInfoSuccess,
  updateSpouseInfoFailed,
  updateChildrenInfoSuccess,
  updateChildrenInfoFailed,
  updateEmergencyContactInfoSuccess,
  updateEmergencyContactInfoFailed,
  updatePermanentAddressInfoSuccess,
  updatePermanentAddressInfoFailed,
  updatePresentAddressInfoSuccess,
  updatePresentAddressInfoFailed,
  deleteChildInfoFailed,
  deleteChildInfoSuccess,
  deleteSpouseInfoSuccess,
  deleteSpouseInfoFailed,
} from "@actions/HRM/employee/family-actions";
import {
  GET_EMPLOYEE_FAMILY,
  UPDATE_PARENT_INFO,
  UPDATE_SPOUSE_INFO,
  UPDATE_CHILDREN_INFO,
  UPDATE_EMERGENCY_CONTACT_INFO,
  UPDATE_PERMANENT_ADDRESS_INFO,
  UPDATE_PRESENT_ADDRESS_INFO,
  DELETE_CHILD_INFO,
  DELETE_SPOUSE_INFO
} from "@actions/HRM/employee/types";

import { isRequestCancelled } from "@helpers/routing";
import { StoreType } from "@reducers/types";

export const familyInfoMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: FamilyActions) => {
      const nextAction = next(action);
      switch (action.type) {
        case GET_EMPLOYEE_FAMILY.GET_FAMILY_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await getFamily(payload);

            dispatch(getFamilySuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getFamilyFailed());
            }
          }
          break;
        }

        case UPDATE_PARENT_INFO.UPDATE_PARENT_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateParentInfo(payload);

            dispatch(updateParentInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateParentInfoFailed());
            }
          }

          break;
        }

        case UPDATE_SPOUSE_INFO.UPDATE_SPOUSE_INFO_REQUEST: {
          try {
            const { payload } = action as any;

            const { data } = await updateSpouseInfo(payload);

            dispatch(updateSpouseInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateSpouseInfoFailed());
            }
          }

          break;
        }

        case UPDATE_CHILDREN_INFO.UPDATE_CHILDREN_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateChildInfo(payload);

            dispatch(updateChildrenInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateChildrenInfoFailed());
            }
          }

          break;
        }

        case UPDATE_EMERGENCY_CONTACT_INFO.UPDATE_EMERGENCY_CONTACT_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateEmergencyContactInfo(payload);

            dispatch(updateEmergencyContactInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateEmergencyContactInfoFailed());
            }
          }

          break;
        }

        case UPDATE_PERMANENT_ADDRESS_INFO.UPDATE_PERMANENT_ADDRESS_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updatePermanentAddressInfo(payload);

            dispatch(updatePermanentAddressInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updatePermanentAddressInfoFailed());
            }
          }

          break;
        }

        case UPDATE_PRESENT_ADDRESS_INFO.UPDATE_PRESENT_ADDRESS_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updatePresentAddressInfo(payload);

            dispatch(updatePresentAddressInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updatePresentAddressInfoFailed());
            }
          }

          break;
        }

        case DELETE_CHILD_INFO.DELETE_CHILD_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteChildInfo(payload);

            dispatch(deleteChildInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteChildInfoFailed());
            }
          }

          break;
        }

        case DELETE_SPOUSE_INFO.DELETE_SPOUSE_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteSpouseInfo(payload);

            dispatch(deleteSpouseInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteSpouseInfoFailed());
            }
          }

          break;
        }
      }
      return nextAction;
    };
  };
};
